import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    editContainer: {
        marginTop: Theme.BU * 2,
        marginBottom: Theme.BU,
        marginHorizontal: Theme.BU,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    categoryTitle: {
        color: 'white',
        textTransform: 'uppercase',
        fontSize: 25,
        fontFamily: Theme.regularFont
    },
    buttonButton: {
        minWidth: 30,
        height: 45
    },
    toggleButton: {
        height: 45
    },
    buttonIcon: {
        width: 27,
        height: 27,
        alignSelf: 'center'
    },
    buttonText: {
        width: 0,
        lineHeight: 0
    },
    buttonTextContainer: {
        paddingRight: 0
    },
    buttonTextContainerSelectAll: {
        paddingRight: 0,
        paddingLeft: Theme.BU
    }
};

export default StyleSheet.create(baseStyles);
